// extracted by mini-css-extract-plugin
module.exports = {"root":"Carousel_root_1V3Va","card":"Carousel_card_2km5V"};